import { apiBase } from "./base";

export const apiErrorReport = {
	client: apiBase.get_client(),
	url: "/error_report/",

	send(body) {
		return this.client.post(`${this.url}`, body, apiBase.get_headers());
	},
};
